var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "section",
      { staticClass: "cropper-area", attrs: { id: "cropperBanner" } },
      [
        _c("div", { staticClass: "header-component" }, [
          _c("div", { staticClass: "title-component" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "close",
              on: {
                click: function($event) {
                  _vm.$emit("close-modal")
                }
              }
            },
            [_vm._v("\n        ×\n      ")]
          )
        ]),
        _vm._v(" "),
        _c("input", {
          ref: "inputImage",
          staticClass: "d-none",
          attrs: { type: "file" },
          on: {
            change: function($event) {
              _vm.handleFileUpload($event, false)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "img-cropper" },
          [
            _c("vue-cropper", {
              ref: "cropper",
              attrs: { src: _vm.imgUrl, preview: ".preview" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "px-4 py-3" }, [
          _c("div", { staticClass: "wrap-setting" }, [
            _c(
              "div",
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center mb-3"
                  },
                  [
                    _c("label", { staticClass: "m-0" }, [_vm._v("Zoom")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "m-0" }, [
                      _vm._v(_vm._s(_vm.zoom))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("b-form-input", {
                  staticClass: "form-range p-0",
                  attrs: { type: "range", min: "0", max: "5", step: "0.5" },
                  model: {
                    value: _vm.zoom,
                    callback: function($$v) {
                      _vm.zoom = $$v
                    },
                    expression: "zoom"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center mb-3"
                  },
                  [
                    _c("label", { staticClass: "m-0" }, [_vm._v("Rotate")]),
                    _vm._v(" "),
                    _c("label", { staticClass: "m-0" }, [
                      _vm._v(_vm._s(_vm.rotate))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("b-form-input", {
                  staticClass: "form-range p-0",
                  attrs: { type: "range", min: "-45", max: "45", step: "1" },
                  model: {
                    value: _vm.rotate,
                    callback: function($$v) {
                      _vm.rotate = $$v
                    },
                    expression: "rotate"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn-rotate", on: { click: _vm.rotateImage } },
              [
                _c("img", {
                  attrs: { src: require("@/assets/icon/rotate.svg") }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-end align-items-center mt-5"
            },
            [
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn gray mr-2",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.changeImage($event)
                        }
                      }
                    },
                    [_vm._v("\n            Change Photo\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "btn blue",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.cropImage($event)
                        }
                      }
                    },
                    [_vm._v("\n            Save\n          ")]
                  )
                ],
                1
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-feb0d008", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-feb0d008","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cropping/jCroppingImage.vue
// module id = null
// module chunks = 